var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatarAuthor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#27272A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2095_6418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5074 36.0988C40.0733 35.9074 37.7642 35.4661 35.6986 34.0816C32.9616 32.2447 31.6058 29.5568 31.7435 26.1395C31.8834 22.6367 33.5569 20.0861 36.5631 18.6881C40.3952 16.9052 44.3398 16.9007 48.1954 18.562C51.7673 20.0996 53.4344 23.222 53.2015 27.4294C53.0045 30.9953 50.6084 34.066 46.9519 35.214C45.5135 35.6619 43.9903 35.8106 42.5074 36.0988ZM45.9796 26.7608C45.719 25.7388 45.5834 24.8428 45.2614 24.0302C44.7615 22.7717 43.8442 21.9636 42.499 21.9748C41.1643 21.9838 40.2427 22.7808 39.7132 24.0257C38.9823 25.7456 38.9547 27.5262 39.7238 29.2326C40.8233 31.6707 43.6874 31.9431 44.9818 29.6964C45.4944 28.8072 45.6724 27.6996 45.9796 26.7608Z",
    fill: "#A1A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3322 18.1977C30.6226 20.7506 29.1482 23.0355 27.5827 25.2461C27.034 26.0206 27.089 26.5451 27.589 27.297C29.1164 29.5909 30.5718 31.9389 32.0526 34.2711C32.2242 34.5412 32.3704 34.8294 32.6098 35.2549C32.1712 35.3067 31.8746 35.3697 31.5781 35.372C29.5655 35.3809 27.5551 35.3517 25.5426 35.39C24.8582 35.4035 24.443 35.1401 24.0872 34.5278C23.3117 33.1973 22.4708 31.9097 21.5492 30.4329C20.6531 31.8736 19.8206 33.1568 19.0473 34.476C18.6745 35.1153 18.2402 35.4079 17.5093 35.3922C15.3337 35.3472 13.158 35.3764 10.6667 35.3764C12.6835 32.1843 14.5371 29.2533 16.4353 26.2479C14.7002 23.6613 12.9673 21.077 11.1327 18.3418C11.5416 18.2743 11.7916 18.1955 12.0437 18.1955C14.0202 18.1842 15.9989 18.1414 17.9712 18.227C18.4309 18.2472 19.0071 18.6187 19.2994 19.0171C20.0896 20.1022 20.7569 21.2886 21.5641 22.5808C22.4348 21.2548 23.1995 20.0549 24.0003 18.8866C24.1909 18.6074 24.5045 18.2337 24.7672 18.2292C27.1886 18.1775 29.6079 18.1977 32.3322 18.1977Z",
    fill: "#A1A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6852 39.3174C28.7501 42.55 36.6626 42.55 44.7128 39.3219C44.7128 40.8595 44.7594 42.3093 44.6747 43.75C44.6577 44.0448 44.1895 44.432 43.8527 44.5672C39.567 46.296 35.1204 46.8971 30.5573 46.5887C27.5151 46.3838 24.5535 45.767 21.6787 44.6617C20.933 44.3758 20.6216 43.9661 20.6682 43.1083C20.7339 41.8905 20.6852 40.6635 20.6852 39.3174Z",
    fill: "#A1A1AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2095_6418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6667,
    height: 29.3333,
    fill: "white",
    transform: "translate(10.6667 17.333)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarAuthor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-author.1d6e71c3ed9d0512c3ec1cbb951bb591.svg";